// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignScheduleSummaryResult = objectOf({
  display_text: string,
  next_occurrence: number,
  last_occurrence: number,
});
